angular.module 'app'
.controller 'WeclomeCtrl', ($scope) ->

